import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FlaskConical, Mail, Activity } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const AuthTestingPage = lazy(() =>
  import('./pages/AuthTestingPage').then((m) => ({ default: m.AuthTestingPage })),
)
const EmailTestingPage = lazy(() =>
  import('./pages/EmailTestingPage').then((m) => ({ default: m.EmailTestingPage })),
)
const MonitoringTestingPage = lazy(() =>
  import('./pages/MonitoringTestingPage').then((m) => ({ default: m.MonitoringTestingPage })),
)

/**
 * DevTools Feature
 *
 * Development-only tools for testing integrations:
 * - Auth: Test authentication endpoints and token flow
 * - Email: Test SES email sending via LocalStack
 * - Monitoring: Test metrics, logging, and error tracking
 *
 * Automatically excluded in production (devOnly: true).
 */

const feature: FrontendFeature = {
  navItems: [
    { path: '/devtools/auth', label: 'DevTools: Auth', icon: FlaskConical },
    { path: '/devtools/email', label: 'DevTools: Email', icon: Mail },
    { path: '/devtools/monitoring', label: 'DevTools: Monitoring', icon: Activity },
  ],
  routes: [
    <Route key="devtools-auth" path="/devtools/auth" element={lazyRoute(<AuthTestingPage />)} />,
    <Route
      key="devtools-email"
      path="/devtools/email"
      element={
        <ProtectedRoute requiredPermissions={['admin:*']}>
          {lazyRoute(<EmailTestingPage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="devtools-monitoring"
      path="/devtools/monitoring"
      element={
        <ProtectedRoute requiredPermissions={['admin:*']}>
          {lazyRoute(<MonitoringTestingPage />)}
        </ProtectedRoute>
      }
    />,
  ],
}

export default feature
